import {
  format as formatSDK,
  formatDate as formatDateSDK,
} from '@dynatrace-sdk/units';

/**
 * Formats the date with the default configuration
 * @internal
 */
export function formatDateDefault(value: number | Date) {
  const valueAsDate = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(valueAsDate.getTime())) {
    return '';
  }

  return formatDateSDK(valueAsDate, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
}

/**
 * Formats a given number with default currency configuration
 * (no currency symbol, but two fraction digits, e.g. 12345.6789 → 12,345.68).
 *
 * @param value - The number to be formatted as currency.
 * @param formatOptions - The format options configured by the consumer.
 *
 * @internal
 */
export function formatCurrencyDefault(
  value: number,
  formatOptions: Omit<Intl.NumberFormatOptions, 'currency' | 'style'> & {
    locale?: string | string[];
    abbreviate?: boolean;
  } = {},
) {
  return formatSDK(value, {
    abbreviate: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...formatOptions,
  });
}
